<template>
  <div class="help-center-mobile-menu-group__component">
    <p
      v-if="menuGroup.title"
      class="help-center-mobile-menu-group__header"
    >
      {{ menuGroup.title }}
    </p>
    <div class="help-center-mobile-menu-group__items">
      <HelpCenterMobileMenuItem
        v-for="menuItem in menuGroup.menu_items"
        :key="menuItem.id"
        :menu-item="menuItem"
        :selected-tab="selectedTab"
        @navigate="onNavigate"
      />
    </div>
  </div>
</template>

<script setup>
import HelpCenterMobileMenuItem from 'help-center/components/HelpCenterMobileMenuItem'

const emit = defineEmits(['navigate'])

defineProps({
  menuGroup: {
    type: Object,
    required: true
  },
  selectedTab: {
    type: Object,
    required: true
  }
})

function onNavigate() {
  emit('navigate')
}
</script>

<style lang="scss">
@import 'help-center/mixins';

.help-center-mobile-menu-group {
  &__component {
    gap: 8px;
    display: flex;
    flex-direction: column;
  }

  &__header {
    @include help-center-font(12);
    color: var(--help-center-muted);
    font-weight: var(--help-center-bold);
    text-transform: uppercase;
  }

  &__items {
    gap: 8px 20px;
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
}
</style>
